export default {
      id: "logo-lely-usage",
      viewBox: "0 0 26 17",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#logo-lely",
      toString: function () {
        return this.url;
      }
    }